import { useParams } from 'react-router';
import { Link } from 'react-router';
import type { ContentCollection } from '../content/types';
import { collectionLabel, collectionBasePath } from '../content/types';
import { getArticle } from '../content';
import { ArticleLayout } from '../components/content/ArticleLayout';
import { MarketingHeader } from '../components/marketing/MarketingHeader';
import { MarketingFooter } from '../components/MarketingFooter';

interface ArticlePageProps {
  collection: ContentCollection;
}

/**
 * Renders a single content article (guide, use-case, or alternatives listicle)
 * resolved from the URL slug. One component serves every article in a
 * collection so new pages auto-register by simply adding a content entry.
 */
export function ArticlePage({ collection }: ArticlePageProps) {
  const { slug = '' } = useParams();
  const article = getArticle(collection, slug);

  if (!article) {
    return (
      <div className="min-h-screen flex flex-col bg-[#fafafa] dark:bg-neutral-950">
        <MarketingHeader />
        <main className="flex-1 flex items-center justify-center px-4 py-24 text-center">
          <div>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Page not found</h1>
            <p className="mt-3 text-slate-600 dark:text-neutral-400">
              We couldn&rsquo;t find that {collectionLabel(collection).toLowerCase()} page.
            </p>
            <Link
              to={collectionBasePath(collection)}
              className="mt-6 inline-flex items-center text-amber-600 dark:text-amber-400 hover:underline"
            >
              Browse all {collectionLabel(collection).toLowerCase()} &rarr;
            </Link>
          </div>
        </main>
        <MarketingFooter />
      </div>
    );
  }

  return <ArticleLayout article={article} />;
}
